import { RRule, Weekday } from 'rrule'

export default {
  methods: {
    /**
     * Create a validated rrule against a rule string and a date
     * @param fromStr
     * @param date
     * @returns {string}
     */
    createValidatedRrule (fromStr, date) {
      const newRrule = RRule.fromString(fromStr)
      newRrule.origOptions.dtstart = this.luxon.fromSQL(date, { zone: 'UTC' }).toJSDate()

      const { bysetpos, bymonthday, byyearday, byweekday, bymonth } = this.baseGetSpecificRecurringFixes(
        newRrule.origOptions.freq,
        (newRrule.origOptions.byweekday || []).map(item => item.weekday),
        date
      )
      newRrule.origOptions.bymonthday = bymonthday
      newRrule.origOptions.byyearday = byyearday
      newRrule.origOptions.byweekday = byweekday
      if (bysetpos !== null) {
        newRrule.origOptions.bysetpos = bysetpos
      }
      if (bymonth !== null && (!newRrule.origOptions.bymonth || newRrule.origOptions.bymonth.length < 1)) {
        newRrule.origOptions.bymonth = bymonth
      }
      return newRrule.toString()
    },
    /**
     * Apply any non-UI values when creating/updating the rule
     * @param freq
     * @param weekdays
     * @param currDate
     * @returns {{byyearday: null, byweekday: null, bysetpos: null, bymonthday: null}}
     */
    baseGetSpecificRecurringFixes (freq, weekdays, currDate = null) {
      const values = {
        bysetpos: null,
        bymonthday: null,
        byyearday: null,
        byweekday: null,
        bymonth: null
      }

      if (!currDate) {
        return values
      }
      currDate = this.luxon.fromSQL(currDate)

      const hasWeekdays = !!weekdays && Array.isArray(weekdays) && weekdays.length > 0

      // Rules may not always loop over each month if the month doesn't end in 31 (for example)
      if (freq === RRule.MONTHLY) {
        if (currDate.day >= 29) {
          values.bysetpos = -1
          // We need to select all dates from 22nd onward because the least amount of days within any month
          // is 28 (in Feb) - and minus a week's worth of days to ensure no skips will happen
          // If selected to only recur on specific days of week
          values.bymonthday = [22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
        }
      }
      else if (freq === RRule.YEARLY) {
        if (currDate.day === 29 && currDate.month === 2) { // February
          values.bysetpos = -1
          // As above, support selecting specific days and ensuring years aren't skipped
          values.byyearday = [54, 55, 56, 57, 58, 59, 60] // stop from creating an event every 4 years (leap year)
        }

        // Set the month for the rule. By default yearly rules with a day of week will start at beginning of year
        if (hasWeekdays) {
          values.bymonth = [currDate.month]
        }
      }

      // Set the current nth week in the period if they have selected spcific days
      let weekInMonth = this.weekInMonth(currDate)
      if ([1, 5].includes(weekInMonth) || freq === RRule.DAILY || freq === RRule.WEEKLY) {
        weekInMonth = null
      }
      if (hasWeekdays) {
        values.byweekday = weekdays.map(item => {
          return new Weekday(item).nth(weekInMonth)
        })
      }
      return values
    }
  }
}
